import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive, watch, inject } from 'vue';
import { api } from '@/services/api';
import type ClientRequest from '@/models/clientRequest';
import ClientAddedModal from '@/components/ClientAddedModal.vue';

// Inject the refresh method

export default /*@__PURE__*/_defineComponent({
  __name: 'AddClientView',
  setup(__props) {

const refreshClients = inject('refreshClients') as () => Promise<void>;

const clientRequest = reactive<ClientRequest>({
  name: '',
  contact: {
    name: '',
    email: ''
  }
});

const clientId = ref('');
const loading = ref(false);
const clientNameError = ref('');
const contactNameError = ref('');
const contactEmailError = ref('');
const showUriModal = ref(false);
const form = ref();

const clearErrors = () => {
  clientNameError.value = '';
  contactNameError.value = '';
  contactEmailError.value = '';
};

const submitForm = async () => {
  if (!clientRequest.name.trim()) {
    clientNameError.value = 'Client name is required';
    return;
  }

  loading.value = true;
  clearErrors();

  try {
    clientId.value = await api.addClient(clientRequest);
    if (clientId.value) {
      console.log(clientId.value + ' is the client id as returned from the api');
      
      // Refresh the client list after successful addition
      await refreshClients();
      
      showUriModal.value = true;
    }

    loading.value = false;
    
    // Wait for modal to close before resetting form
    await new Promise(resolve => {
      const unwatch = watch(showUriModal, (newValue) => {
        if (!newValue) {
          unwatch();
          resolve(true);
        }
      });
    });

    // Reset form after modal is closed
    Object.assign(clientRequest, {
      name: '',
      id: '',
      contact: {
        name: '',
        email: ''
      }
    });
  } catch (error) {
    clientNameError.value = 'Failed to add client. Please try again.';
    console.error('Error adding client:', error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
        icon: "mdi-arrow-left",
        class: "mb-4"
      }),
      _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Add New Client", -1)),
      _createVNode(_component_v_form, {
        onSubmit: _withModifiers(submitForm, ["prevent"]),
        ref_key: "form",
        ref: form
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: clientRequest.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientRequest.name) = $event)),
            label: "Client Name",
            required: "",
            "error-messages": clientNameError.value,
            onInput: clearErrors
          }, null, 8, ["modelValue", "error-messages"]),
          _createVNode(_component_v_text_field, {
            modelValue: clientRequest.contact.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((clientRequest.contact.name) = $event)),
            label: "Contact Name",
            required: "",
            "error-messages": contactNameError.value,
            onInput: clearErrors
          }, null, 8, ["modelValue", "error-messages"]),
          _createVNode(_component_v_text_field, {
            modelValue: clientRequest.contact.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((clientRequest.contact.email) = $event)),
            label: "Contact Email",
            required: "",
            type: "email",
            "error-messages": contactEmailError.value,
            onInput: clearErrors
          }, null, 8, ["modelValue", "error-messages"]),
          _createVNode(_component_v_btn, {
            type: "submit",
            color: "primary",
            loading: loading.value,
            disabled: loading.value
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Add Client ")
            ])),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      }, 512),
      _createVNode(ClientAddedModal, {
        modelValue: showUriModal.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showUriModal).value = $event)),
        "client-id": clientId.value
      }, null, 8, ["modelValue", "client-id"])
    ]),
    _: 1
  }))
}
}

})